import { EVillageClass } from '../../types/filters';

interface IVillageClass {
  label: string;
  value: EVillageClass;
}

export const VILLAGE_CLASSES: IVillageClass[] = [
  { label: 'Эконом', value: EVillageClass.Economy },
  { label: 'Комфорт', value: EVillageClass.Comfort },
  { label: 'Бизнес', value: EVillageClass.Business },
  { label: 'Элитный', value: EVillageClass.Elite },
];
